import React, { memo } from "react"
import PropTypes from "prop-types"
import { CloseCircleOutlined, EditOutlined } from "@ant-design/icons"
import styles from "../ImportReport.module.css"

/**
 * Error List Item Component
 * Displays a single error record in the list
 * Follows Single Responsibility Principle - only handles error item display
 * Memoized to prevent unnecessary re-renders
 *
 * @param {Object} props - Component props
 * @param {string|number} props.rowNumber - The row number in the spreadsheet
 * @param {string} props.clientName - The client's full name
 * @param {number} props.errorCount - Number of errors in this row
 * @param {Function} props.onEdit - Callback when edit button is clicked
 */
const ErrorListItem = memo(({ rowNumber, clientName, errorCount, onEdit }) => {
  return (
    <div className={styles.errorItem}>
      <div className={styles.errorHeader}>
        <div className={styles.rowInfo}>
          <span className={styles.rowNumber}>{rowNumber}</span>
          <span className={styles.clientName}>{clientName}</span>
        </div>
        {errorCount > 0 && (
          <div className={styles.errorMessage}>
            <CloseCircleOutlined className={styles.errorIcon} />
            <span>{`${errorCount} error${errorCount > 1 ? "s" : ""} in this row`}</span>
          </div>
        )}
        <EditOutlined className={styles.editIcon} onClick={onEdit} />
      </div>
    </div>
  )
})

ErrorListItem.displayName = "ErrorListItem"

ErrorListItem.propTypes = {
  rowNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  clientName: PropTypes.string.isRequired,
  errorCount: PropTypes.number.isRequired,
  onEdit: PropTypes.func.isRequired
}

export default ErrorListItem
